import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 6.5,
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 3.625C8.57453 3.625 9.14344 3.73816 9.67424 3.95803C10.205 4.17789 10.6873 4.50015 11.0936 4.90641C11.4998 5.31266 11.8221 5.79496 12.042 6.32576C12.2618 6.85656 12.375 7.42547 12.375 8C12.375 8.57453 12.2618 9.14344 12.042 9.67424C11.8221 10.205 11.4998 10.6873 11.0936 11.0936C10.6873 11.4998 10.205 11.8221 9.67424 12.042C9.14344 12.2618 8.57453 12.375 8 12.375L8 8L8 3.625Z",
		fill: "currentColor"
	})]
});
export default SvgStatus;
